import axios from 'axios'
import * as Actions from './ActionTypes'

export const authSuccess=(token,userId)=>{
    return {
        type:Actions.AUTH_SUCCESS,
        payload:{
            token:token,
            userId:userId
        }
    }
}

export const authLogout=()=>{
    localStorage.removeItem('token')
    localStorage.removeItem('userId')
    localStorage.removeItem('experDate')
    return{
        type:Actions.AUTH_LOGOUT
    }
}

export const authLoading=isLoading=>{
    return{
        type:Actions.AUTH_LOADING,
        payload:isLoading
    }
}

export const authError=errMsg=>{
    return{
        type:Actions.AUTH_FAILED,
        payload:errMsg
    }
}

export const auth=(email,password,mode)=>dispatch=>{
    dispatch(authLoading(true));
    const authBody={
        email:email,
        password:password,
        returnSecureToken:true
    }
    console.log(authBody);
    const API_KEY="AIzaSyDIANUYz9v-fWmAaGgRc9C_69xxibK0jlI";
    let authURL=null;
    if(mode==="Sign Up"){
        authURL="https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=";
    }
    else{
        authURL="https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=";
    }
    console.log(authBody);
    
    axios.post(authURL+API_KEY, authBody)
    .then((response) => {
        console.log(response);
        localStorage.setItem('token',response.data.idToken);
        localStorage.setItem('userId',response.data.localId);
        const exper=new Date(new Date().getTime() + response.data.expiresIn*1000)
        localStorage.setItem('experDate',exper);
        dispatch(authSuccess(response.data.idToken,response.data.localId))
    })
    .catch(err=>
        // console.log(err.response.data.error.message)
        dispatch(authError(err.response.data.error.message))
        )
}

export const authCheck=()=>dispatch=>{
    dispatch(authLoading(true));
    let token=localStorage.getItem('token')
    if(!token){
        dispatch(authLoading(false));
        dispatch(authLogout())
    }
    else{
        let exper=localStorage.getItem('experDate')
        if(exper>=new Date()){
            dispatch(authLoading(false));
            dispatch(authLogout())
        }
        else{
            dispatch(authLoading(false));
            let userId=localStorage.getItem('userId')
            dispatch(authSuccess(token,userId))
        }
    }
}